import headerLogo from "../../../assets/images/header/header-logo.svg";
import {useCookies} from "react-cookie";
import {useNavigate} from "react-router-dom";
import * as Routes from "../../../constants/Routes";
import {useDispatch, useSelector} from "react-redux";
import {removeTokenValue} from "../../../redux/reducers/auth.reducer";

export default function Header() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [, , removeCookie] = useCookies(["admin_token"]);
    const tokenValue = useSelector((state: any) => state.auth.tokenValue);

    const logout = () => {
        removeCookie("admin_token");
        dispatch(removeTokenValue());
        navigate(Routes.LOGIN);
    }

    return (
        <header className="header-back-office">
            <div className="header-wrapper">
                <div className="header-wrapper-office">
                    <img src={headerLogo} alt="logo"/>
                    <div className="header-office-icon">
                        백오피스
                    </div>
                </div>
                {tokenValue &&
                    <div onClick={() => logout()} className="login-info">
                        로그아웃
                    </div>
                }
            </div>
        </header>
    );
}